/**
 *
 * CheckoutStep1Page
 *
 */

import { push } from 'connected-react-router';
import messages from 'containers/CheckoutPage/messages';
import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { compose, Dispatch } from 'redux';
import { createStructuredSelector } from 'reselect';
import translations from 'translations';

import CheckoutStep2 from 'components/Checkout/CheckoutStep2';
import {
  createOrderDraft,
  getVouchers,
  onChangeInvoiceNote,
  setOpenConfirmSameDayDeliveryModal,
} from 'containers/CheckoutPage/actions';
import {
  selectCheckout,
  selectCurrentAppliedVoucher,
  selectDiscountedValue,
  selectInvoiceNote,
  selectLoadingCheckout,
  selectOpenConfirmSameDayDeliveryModal,
  selectVoucherStatus,
} from 'containers/CheckoutPage/selectors';
import { selectCart, selectOrderDisabled } from 'containers/MainLayout/selectors';
import { Voucher } from 'types/schema';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import { VOUCHER_STATUS } from '../CheckoutPage/constants';
import { addNoteSubmit, saveInvoiceNote, updateDeliveryDetails, updateDeliveryNote } from './actions';
import reducer from './reducer';
import saga from './saga';
import { RootState } from './types';

interface OwnProps {
  cart: any;
  checkout: any;
  orderDisabled: {
    orderDisabled: boolean;
  };
  createOrderDraftLoading: boolean;
  openConfirmSameDayDeliveryModal: boolean;
  currentAppliedVoucher: Voucher | null;
  voucherStatus: VOUCHER_STATUS | null;
  discountedValue: number;
  checkoutstep1page: any;
  invoiceNote?: string;
}

interface StateProps {}

interface DispatchProps {
  onGoPreviousStep: () => void;
  onCreateOrderDraft: () => void;
  onUpdateDeliveryDetails: (data: any) => void;
  onSaveNote: (data: any) => void;
  onUpdateDeliveryNote: (data: any) => void;
  setOpenConfirmSameDayDeliveryModal: (data: boolean) => void;
  onGetVouchers: (data: any) => void;
  onSaveInvoiceNote: (data: any) => void;
  onChangeInvoiceNote: (data?: string) => void;
}

type Props = StateProps & DispatchProps & OwnProps;

export class CheckoutStep2Page extends React.PureComponent<Props> {
  public render() {
    return (
      <Fragment>
        <Helmet>
          <title>{translations(messages.headerStep2)}</title>
          <meta name="description" content={`${translations(messages.headerStep2)}`} />
        </Helmet>
        <CheckoutStep2
          loading={this.props.cart?.loading}
          createOrderDraftLoading={this.props.createOrderDraftLoading}
          checkout={this.props.checkout}
          onChangeDeliveryDate={this.props.onUpdateDeliveryDetails}
          onChangeDeliveryTime={this.props.onUpdateDeliveryDetails}
          onGoPreviousStep={this.props.onGoPreviousStep}
          onCreateOrderDraft={this.props.onCreateOrderDraft}
          onSaveNote={this.props.onSaveNote}
          onUpdateDeliveryNote={this.props.onUpdateDeliveryNote}
          cart={this.props.cart}
          deliveryFee={this.props.cart?.deliveryFee}
          orderDisabled={this.props.orderDisabled.orderDisabled}
          openConfirmSameDayDeliveryModal={this.props.openConfirmSameDayDeliveryModal}
          setOpenConfirmSameDayDeliveryModal={this.props.setOpenConfirmSameDayDeliveryModal}
          currentAppliedVoucher={this.props.currentAppliedVoucher}
          voucherStatus={this.props.voucherStatus}
          discountedValue={this.props.discountedValue}
          getVouchers={this.props.onGetVouchers}
          invoiceNote={this.props.invoiceNote}
          onSaveInvoiceNote={this.props.onSaveInvoiceNote}
          onChangeInvoiceNote={this.props.onChangeInvoiceNote}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = createStructuredSelector<RootState, StateProps>({
  cart: selectCart(),
  checkout: selectCheckout(),
  createOrderDraftLoading: selectLoadingCheckout(),
  orderDisabled: selectOrderDisabled(),
  openConfirmSameDayDeliveryModal: selectOpenConfirmSameDayDeliveryModal(),
  currentAppliedVoucher: selectCurrentAppliedVoucher(),
  voucherStatus: selectVoucherStatus(),
  discountedValue: selectDiscountedValue(),
  invoiceNote: selectInvoiceNote(),
});

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
  return {
    onCreateOrderDraft: () => dispatch(createOrderDraft()),
    onGoPreviousStep: () => dispatch(push('/checkout/step/1')),
    onUpdateDeliveryDetails: (data: any) => dispatch(updateDeliveryDetails(data)),
    onSaveNote: (data: any) => dispatch(addNoteSubmit(data)),
    onUpdateDeliveryNote: (data: any) => dispatch(updateDeliveryNote(data)),
    setOpenConfirmSameDayDeliveryModal: (data: boolean) => dispatch(setOpenConfirmSameDayDeliveryModal(data)),
    onGetVouchers: (data: any) => dispatch(getVouchers(data)),
    onSaveInvoiceNote: (data: any) => dispatch(saveInvoiceNote(data)),
    onChangeInvoiceNote: (data?: string) => dispatch(onChangeInvoiceNote(data)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

// <OwnProps> restricts access to the HOC's other props. This component must not do anything with reducer hoc
const withReducer = injectReducer<OwnProps>({
  key: 'checkoutStep2Page',
  reducer: reducer,
});
// <OwnProps> restricts access to the HOC's other props. This component must not do anything with saga hoc
const withSaga = injectSaga<OwnProps>({ key: 'checkoutStep2Page', saga: saga });

export default compose(withReducer, withSaga, withConnect)(CheckoutStep2Page);
